import { render, staticRenderFns } from "./OfferSidebar.vue?vue&type=template&id=668c8802&scoped=true&"
import script from "./OfferSidebar.vue?vue&type=script&lang=js&"
export * from "./OfferSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c8802",
  null
  
)

export default component.exports